import { h } from '../utils'
import { fieldError } from './error'
import { uniqueId } from './id'
import { fieldLabel } from './label'

interface RadioFieldOptions {
  label: string
  name: string
  choices: { value: string; label: string; disabled?: boolean; selected?: boolean }[]
  defaultValue?: string | null
  required?: boolean
  hidden?: boolean
}

export function radioField(options: RadioFieldOptions) {
  const id = uniqueId()
  const control = h('div', { class: 'vbzc-control vbzc-radio-group' })

  // Radio buttons
  const radios: HTMLInputElement[] = []
  for (const [i, choice] of options.choices.entries()) {
    const radioWrapper = h('div', { class: 'vbzc-radio-wrapper' }, { parent: control })

    const props: Record<string, string> = {
      class: 'vbzc-radio',
      type: 'radio',
      id: `${id}-${i}`,
      name: options.name,
      value: choice.value,
    }
    if (choice.disabled) props['disabled'] = ''
    if (choice.selected || choice.value === options.defaultValue) props['checked'] = ''

    const radio = h('input', props, { parent: radioWrapper }) as HTMLInputElement
    radios.push(radio)

    h(
      'label',
      { class: 'vbzc-radio-label', for: `${id}-${i}` },
      {
        text: choice.label,
        parent: radioWrapper,
      },
    )
  }

  // Error
  const { el: error } = fieldError()

  // Field
  const field = h(
    'div',
    { 'class': 'vbzc-field' + (options.hidden ? ' vbzc-field-hidden' : ''), 'data-name': options.name },
    { children: [fieldLabel({ text: options.label, id, required: options.required }), control, error] },
  ) as HTMLDivElement

  return { field, radios, error }
}
